export default __webpack_public_path__ + "static/media/img_shouye_jishu_03.b5b7eb5c.png";